import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView/HomeView.vue'
import jkfx from '../views/HomeView/child/jkfx.vue'
import qygk from '../views/HomeView/child/qygk.vue'
import shjjzb from '../views/HomeView/child/shjjzb.vue'
import wrtz from '../views/HomeView/child/wrtz.vue'
import Login from '../views/Login.vue'
import backGround from '../views/backGround.vue'
import datagl from '../views/datagl.vue'
import usergl from '../views/usergl.vue'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const routes = [
  {
    path: '/',
    name: '/',
    component: Login
  },

  {
    path: '/HomeView',
    name: 'HomeView',
    component: HomeView,
    redirect: '/HomeView/qygk',
    children:[
      {
        path:'/HomeView/qygk',
        name: 'qygk',
        component: qygk
      },
      {
        path:'/HomeView/shjjzb',
        name: 'shjjzb',
        component: shjjzb
      },
      
      {
        path:'/HomeView/wrtz',
        name: 'wrtz',
        component: wrtz
      },
      {
        path:'/HomeView/jkfx',
        name: 'jkfx',
        component: jkfx
      },
    ]
  },
  {
    path: '/backGround',
    name: 'backGround',
    component: backGround,
    redirect: '/backGround/datagl',
    children:[
      {
        path: '/backGround/datagl',
        name: 'datagl',
        component: datagl
      },
      {
        path: '/backGround/usergl',
        name: 'usergl',
        component: usergl
      },
    ]
  },
 
  {
    path: '/Login',
    name: 'Login',
    component: Login
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
